<template>
  <v-autocomplete
    :items="languagesList"
    v-model="selectedLanguage"
    :label="label"
    item-text="name"
    item-value="id"
    @change="changeListener($event)"
    :outlined="outlined"
    :clearable="clearable"
    @click:clear="onClear"
  ></v-autocomplete>
</template>

<script>
import { ALL_LANGUAGES_SEARCH_QUERY } from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";

export default {
  name: "LanguageListSelect",

  props: {
    languageId: { type: String },
    //for lang name
    value: {
      type: String,
      default: () => "",
    },
    code: { type: String },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    label: {
      type: String,
      default: () => "Language",
    },
    clearable: {
      type: Boolean,
      default: () => false,
    },
    forContent: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      languages: {},
      //languagesList: [{ name: "English", id: "TGFuZ3VhZ2UtNDk2" }],
      selectedLanguage: this.value != "" ? this.value : "",
    };
  },

  computed: {
    languagesList() {
      return this.languages && this.languages.edges
        ? this.forContent
          ? [
              ...this.languages.edges
                .map(removeGQLTypename)
                .filter((c) => c.forContent),
            ]
          : [...this.languages.edges.map(removeGQLTypename)]
        : [];
    },
  },

  methods: {
    changeListener(data) {
      if (typeof data == "string") {
        this.$emit("onSelect", data);
        const selectedLang = this.languagesList.find((l) => l.id == data);
        if (selectedLang) {
          this.$emit("input", selectedLang.id);
        }
      }
    },
    setDefault() {
      if (this.code) {
        let langByCode = this.languagesList.find((l) => l.code == this.code);
        if (langByCode) {
          this.selectedLanguage = langByCode.id;
        }
      }
    },
    setLang(lang) {
      const langByName = this.languagesList.find((l) => l.name == lang);
      if (langByName) {
        this.selectedLanguage = langByName.id;
      } else {
        const langById = this.languagesList.find((l) => l.id == lang);
        if (langById) {
          this.selectedLanguage = lang;
        }
      }
    },
    onClear() {
      this.$emit("input", "");
    },
  },

  watch: {
    languageId: function () {
      //this.selectedLanguage = this.languageId;
      this.setLang(this.languageId);
    },
    code: function (val) {
      this.setDefault();
    },
    value(newVal) {
      //this.setLangByName(langName);
      //this.selectedLanguage = newVal;
      console.log("languageId", newVal);
      this.setLang(newVal);
    },
  },

  apollo: {
    languages: {
      query: ALL_LANGUAGES_SEARCH_QUERY,
      variables() {
        return {};
      },
      result({ data, loader, networkStatus }) {
        // this.languagesList = data.languages.edges.map(node => ({
        //   ...node.node
        // }));
        if (this.languageId != "") {
          this.setLang(this.languageId);
        } else if (this.value != "") {
          this.setLang(this.value);
        } else {
          this.setDefault();
        }
      },
    },
  },
  mounted() {
    if (this.languageId) {
      this.selectedLanguage = this.languageId;
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/LanguageListSelect.vue